import { Client } from "./ApiServer";

export class OldApiClient {
    public GetUnauthenticatedOldClient(domain: string): Client {
        if (domain === "devtest.dev")
            return new Client('http://' + domain + '.vimovsem.cz');
        else return new Client('https://' + domain + '.vimovsem.cz');
    }
}